import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FilterResponseModel } from '../models/filter/filter-response.model';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {

  @Output() renderRibbon: EventEmitter<number> = new EventEmitter();
  authCode: any;
  loggedInUser;
  subscription: string;
  environment: string;
  tagMovMsg;
  
  constructor( public httpClient: HttpClient, public dialog: MatDialog) {
  }
 
  phtHeaders = new HttpHeaders({
    'Accept': '*/*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Headers': 'x-access-token,Content-Type',
    'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
  });

  isAuthorize: boolean = false;
  isActivate: boolean = true;
  userDetails: any;

  gethttpHeader(bearerToken) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Methods': 'POST, GET, PUT',
        'Authorization': 'Bearer ' + bearerToken
      })
    };
    return httpOptions;
  }

  showAlert(model, data) {
    this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
  }

  showAlertWithCallBack(model, data, methodRef: (thisRef: any, result?: any) => void, thisRef) {
    const dialogRef = this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result != null){
        methodRef(thisRef);
      }
    });
  }

  openModelWindow(methodRef: (thisRef: any, result?: any) => void, thisRef, modelComponent, widthOfWindow, panelClassName, dataToPass) {
    {
      const dialogRef = this.dialog.open(modelComponent, {
        width: widthOfWindow,
        panelClass: panelClassName,
        data: dataToPass
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === true && methodRef != null) {
          methodRef(thisRef);
        }
        else if (result !== false && result !== undefined) {
          methodRef(thisRef, result);
        }
      });
    }
  }

  getModelsDescriptions(methodRef: (data: any, thisRef: any) => void, thisRef, modelsDescUrl, accessToken) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'POST, GET',
        'Authorization': 'Bearer ' + accessToken
      })
    };
    this.httpClient.get<any>(modelsDescUrl, httpOptions).subscribe((data: any): void => {
      methodRef(data, thisRef);
    }, (error: Error) => {
      thisRef.errorMessage = 'Error in fetching details, more details: ' + error.message;
      methodRef(null, thisRef);
    });
  }

  /**
   * Replaces display text for filter
   * @param tempText
   */
  replaceDisplayText(tempText: string) {
    if (tempText == "modelName") {
      return "Model Name";
    } else if (tempText == "registrationName") {
      return "Configure Model Name";
    } else if (tempText == "modelTypeName") {
      return "Model Type";
    } else if (tempText == "modelApiVersion") {
      return "Version";
    } else if (tempText == "modelVersion") {
      return "Model Version";
    } else if (tempText == "businessDescription") {
      return "Description";
    } else if (tempText == "businessFunctionTypeName") {
      return "Business Function";
    } else if (tempText == "url") {
      return "Configure API URL";
    } else if (tempText == "type") {
      return "Configure Model Type";
    } else if (tempText == "lastModifiedBy") {
      return "Last Modified By";
    }
  }

  /**
   * Replace filter texts
   * @param tempText
   */
  replaceFilterText(tempText: string): string {
    if (tempText == "Model Name") {
      return "modelName";
    } else if (tempText == "Model Type") {
      return "modelTypeName";
    } else if (tempText == "Version") {
      return "modelApiVersion";
    } else if (tempText == "Description") {
      return "businessDescription";
    } else if (tempText == "Business Function") {
      return "businessFunctionTypeName";
    } else if (tempText == "Configure Model Name") {
      return "registrationName";
    } else if (tempText == "Configure Model Type") {
      return "type";
    } else if (tempText == "Model Version") {
      return "modelVersion";
    } else if (tempText == "Configure API URL") {
      return "url";
    } else if (tempText == "Last Modified By") {
      return "lastModifiedBy";
    } else {
      return "";
    }
  }

  /**
   * 
   * @param filterResponse
   * @param data
   */
  conditionalDataFiltering(filterResponse: FilterResponseModel, data) {
    let temp;
    if (filterResponse.selectedFieldName !== "version") {
      switch(filterResponse.selectedValue.length){
      case 1: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]);
        });
        break;
      } 
      case 2: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1]);
        });
        break; 
      } 
      case 3: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]);
        });
        break;
      } 
      case 4: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[3]);
        });
        break;
      } 
      case 5: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[3])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[4]);
        });
        break;
      }
      default:{
        break;
      }
    }
    } else {
      switch(filterResponse.selectedCondition){
      case "==": {
        temp = data.filter((df) => df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]);
        break;
      }
      case ">=": {
        temp = data.filter((df) => df[filterResponse.selectedFieldName] >= parseInt(filterResponse.selectedValue[0], 10));
        break;
      } 
      case "<=": {
        temp = data.filter((df) => df[filterResponse.selectedFieldName] <= parseInt(filterResponse.selectedValue[0], 10));
        break;
      }
      default:{
        break;
      }
    }
  }
    return temp;
  }

  /**
   * Checks if the given object is not undefined or null.
   * @param data string to be checked
   */
  isNotNullObject(data) {
    let response: boolean = false;
    if (data != undefined && data != null) {
      response = true;
    }
    return response;
  }

  /**
   * Checks if the given string parameter is not undefined, null or empty.
   * @param data string to be checked
   */
  isNotNull(data: string) {
    let response: boolean = false;
    if (data != undefined && data != null && data != "") {
      response = true;
    }
    return response;
  }
  getAssetAppConfig() {
    let request = new XMLHttpRequest();
  request.open('GET', './assets/config/app-config.json', false);
  request.setRequestHeader("Cache-Control", "max-age=0");
  request.send(null);

  if (request.status === 200) {
    let data = JSON.parse(request.responseText);
    return data;
  }
}

}
